import React from 'react'
import { useSelector } from 'react-redux'
import { SupportedBrands } from 'src/enums'
import {
  selectAppName,
  selectBrandName,
} from 'src/redux/selectors/session.selectors'

interface BrandPrimaryLogoProps {
  className?: string
  brand?: SupportedBrands
}

const BrandPrimaryLogo: React.FC<BrandPrimaryLogoProps> = (props) => {
  const currentBrandName = useSelector(selectBrandName)
  const appName = useSelector(selectAppName)

  const brandName = props.brand || currentBrandName

  // TODO: Update primary logo for jpm in s3 - currently using same as brand logo
  return (
    <img
      alt={appName}
      className={props.className}
      src={`https://brand-assets.paywithextend.com/${brandName}/PrimaryLogo.svg`}
    />
  )
}

export default BrandPrimaryLogo
